import { Box, Divider, Stack } from '@mui/material';
import { FC } from 'react';

import { AbgTypography, EditIcon } from '@abg/kit-base';

import {
  amountEditContainerStyling,
  editIconStyles,
  redTextStyles,
  userCardsAmountBoxStyles,
  userCardsAmountWrapperStyles,
} from './split-amount.styling';
import { maskCardNumber } from './split-amount.utils';

interface SplitPaymentAmountsProps {
  onChangeCard: () => void;
  title: string;
  primaryCard: string;
  secondaryCard: string;
  primaryAmount: string;
  secondaryAmount: string;
  pencilRef?: React.RefObject<SVGSVGElement | null>;
}

export const SplitAmount: FC<SplitPaymentAmountsProps> = ({
  onChangeCard,
  title,
  primaryCard,
  secondaryCard,
  primaryAmount,
  secondaryAmount,
  pencilRef,
}) => {
  return (
    <Box sx={userCardsAmountWrapperStyles}>
      <Stack sx={userCardsAmountBoxStyles}>
        <AbgTypography
          variant="bodyRegularMedium"
          data-testid="primary-cart-text-title"
        >
          {title} {maskCardNumber(primaryCard)}
        </AbgTypography>

        <AbgTypography
          variant="bodyRegularMedium"
          data-testid="primary-cart-text-amount"
        >
          {primaryAmount}
        </AbgTypography>
      </Stack>

      <Divider orientation="vertical" flexItem />

      <Stack sx={userCardsAmountBoxStyles}>
        <Stack sx={amountEditContainerStyling}>
          <AbgTypography
            variant="bodyRegularMedium"
            data-testid="secondary-cart-text-title"
          >
            {title}

            <Box component="span" sx={redTextStyles}>
              {' '}
              {maskCardNumber(secondaryCard)}
            </Box>
          </AbgTypography>

          <EditIcon
            data-testid="edit-secondary-card"
            sx={editIconStyles}
            onClick={onChangeCard}
            ref={pencilRef}
          />
        </Stack>

        <AbgTypography
          variant="bodyRegularMedium"
          sx={redTextStyles}
          data-testid="secondary-cart-text-amount"
        >
          {secondaryAmount}
        </AbgTypography>
      </Stack>
    </Box>
  );
};
